import api from "../../index";

export const GetAllWithdrawRequestApi = (params) => api.get(`wallet/getall-withdrawrequests?${params}`);
export const RequestAcceptRejectApi = (data) => api.post('wallet/approved-rejected-withdrawalrequest', data);

export const GetAllWithdrawByIdApi = (params) => api.get(`WalletMaster/GetSingle-WithdrawalById?${params}`);
export const RequestRejectApi = (data) => api.post('Withdraw/Reject-Withdraw-Request', data);

export const AddWithdrawRequestApi = (data) => api.post('wallet/add-withdraw-request', data);
export const GetWalletApi = (id,params) => api.get(`wallet/admin/payment-gatway-rule-details/${id}?${params}`);
